import LabradorArticleFooter, {
  StandaloneArticleFooter,
  StandaloneArticleFooterProps,
} from '@/components/ArticleFooter';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export const AllasStandaloneArticleFooter: StandaloneComponent<StandaloneArticleFooterProps> = (props) => {
  return (
    <StandaloneArticleFooter
      {...mergeProps(
        {
          options: {
            $tags: {
              align: 'center',
            },
          },
        },
        props
      )}
    />
  );
};

export const standalone = AllasStandaloneArticleFooter;

export default LabradorArticleFooter;
